/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export const bidProducts = [
    'PPA: Storage Agreement',
    'PPA: PV+S (physical and virtual)',
    'PPA: As-available (physical and virtual)',
    'Products: Ancillary services',
    'Products: Capacity (accredited capacity, resource adequacy)',
    'Products: Dispatchable solar',
    'Products: Energy',
    'Products: Environmental attributes (RECs)',
    'Products: Structured products (shaped products, firm products, etc.)',
    'Asset sale (build-transfer)',
    'Option agreements',
    'Services: Asset management',
    'Services: O&M',
    'Services: Safety',
];
//# sourceMappingURL=opportunities.js.map